export default __webpack_public_path__ + "static/media/sprchovy-kout.7caa9556.jpeg";